import { GraphQLClient } from 'graphql-request';
import { JdbtCardProjectManagement_FindBusinessInfo2Document } from '@fiverr-private/homepage_gql_utils';
import { statsFunctionWrapper } from '@fiverr-private/homepage_utils';
import { BUSINESS_PURPOSE, COMPANY_SIZE } from '../../types';

/**
 * If response successful: returns the user company size,
 * Otherwise: returns empty BusinessInfo.
 */

export interface BusinessInfo {
    companySize: COMPANY_SIZE | string | undefined | null;
    avgOrderAmount: number | null | undefined;
    purposes: BUSINESS_PURPOSE[] | string[] | null | undefined;
}

export const fetchBusinessInfo = async (route: string, userId: number): Promise<BusinessInfo> => {
    const client = new GraphQLClient(route);
    const fetcher = () =>
        client.request(JdbtCardProjectManagement_FindBusinessInfo2Document, {
            userId: userId.toString(),
        });

    const res = await statsFunctionWrapper(fetcher, 'jtbd.project_management.fetch_business_info')();

    const buyerInfo = res?.buyersByIds?.[0];

    if (!buyerInfo) {
        return {
            companySize: undefined,
            avgOrderAmount: undefined,
            purposes: undefined,
        };
    }

    const { insights, organization } = buyerInfo;

    const { companySize, purposes } = organization?.businessInfo || {};

    return {
        companySize,
        avgOrderAmount: insights?.buyerStatistics?.order?.avgOrderAmount,
        purposes,
    };
};
